import 'react';
import { Text, Button } from 'reaxl';
import { jsx, jsxs } from 'react/jsx-runtime';
function MyWalletWelcomeMessage(_ref) {
  let {
    onGetStartedClick,
    ...rest
  } = _ref;
  return /*#__PURE__*/jsx("div", {
    ...rest,
    children: /*#__PURE__*/jsxs(Text, {
      children: ["See payments tailored to you, estimated loan rates, and budget tools to customize your shopping experience.\xA0\xA0", /*#__PURE__*/jsx(Button, {
        bsStyle: "default",
        bsSize: "small",
        onClick: onGetStartedClick,
        children: "Get Started"
      })]
    })
  });
}
export { MyWalletWelcomeMessage as default };
